import React, { useState } from "react";
import { api } from "../../lib/api";
import { useFetch, act } from "../../lib/useFetch";
import { useAuth } from "../../lib/auth";
import { ORDER_FILTERS } from "../../lib/constants";
import { Plus } from "lucide-react";
import FilterPills from "./FilterPills";
import OrderRow from "./OrderRow";
import OrderDialog from "./OrderDialog";
import { BriefDialog, RejectDialog, DeadlineDialog } from "./OrderActionDialogs";

const HEADERS = ["Клиент", "Услуга", "Цена", "Статус", "Язык клиента", "Дедлайн", "Создан", ""];

export default function OrdersPanel() {
  const { user: me } = useAuth();
  const [filter, setFilter] = useState("all");
  const [data, reload] = useFetch(`/admin/orders?status=${filter}`);
  const [dialog, setDialog] = useState(null);
  const close = () => setDialog(null);
  const done = () => { setDialog(null); reload(); };

  const run = async (o, action) => {
    if (action === "delete") {
      if (!window.confirm("Удалить заказ?")) return;
      await act(api.delete(`/admin/orders/${o.id}`), "Заказ удалён");
    } else {
      await act(api.post(`/admin/orders/${o.id}/${action}`), action === "accept" ? "Заказ принят в работу" : "Заказ отмечен как оказанный");
    }
    reload();
  };
  const orders = data?.orders || [];

  return (
    <div className="glass rounded-2xl p-6" data-testid="panel-orders">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
        <h3 className="font-heading text-2xl font-bold">📋 Заказы</h3>
        {me.role_level >= 7 && (
          <button onClick={() => setDialog({ type: "edit", order: null })} className="btn-gold !py-2 inline-flex items-center gap-2" data-testid="order-add-btn">
            <Plus size={14} /> Заказ
          </button>
        )}
      </div>
      <FilterPills options={ORDER_FILTERS} value={filter} onChange={setFilter} counts={data?.counts} testid="orders-filter" />
      <div className="overflow-x-auto mt-5">
        <table className="w-full text-sm min-w-[1000px]">
          <thead>
            <tr className="text-left text-xs uppercase tracking-widest text-gray-500">{HEADERS.map((h) => <th key={h} className="pb-2 pr-3">{h}</th>)}</tr>
          </thead>
          <tbody>
            {orders.map((o) => <OrderRow key={o.id} o={o} level={me.role_level} onRun={run} onOpen={(type) => setDialog({ type, order: o })} />)}
          </tbody>
        </table>
        {orders.length === 0 && <p className="text-gray-400 mt-4">Заказов нет.</p>}
      </div>
      {dialog?.type === "edit" && <OrderDialog order={dialog.order} onClose={close} onSaved={done} />}
      {dialog?.type === "brief" && <BriefDialog order={dialog.order} onClose={close} />}
      {dialog?.type === "reject" && <RejectDialog order={dialog.order} onClose={close} onSaved={done} />}
      {dialog?.type === "deadline" && <DeadlineDialog order={dialog.order} onClose={close} onSaved={done} />}
    </div>
  );
}
